module.exports = __webpack_public_path__ + "img/@pink_arrow.cf3b5413.svg";